import { Chip } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"
import { useMemo } from "react"

import { INVOICE_DOCUMENT_TYPE_TO_LABEL } from "../constants"
import { isInvoiceDocumentFieldGroup } from "../utils"

import FileChip from "@/components/upload/components/display/FileChip"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { InvoiceDocumentRowActions } from "@/screens/Accounting/subfeatures/Invoices/components/InvoiceRowDetails/InvoiceDocumentRowActions"

interface UseInvoiceFilesColumnsProps {
  onDelete?: (document: SignedUrl) => void
}

export const useInvoiceFilesColumns = ({ onDelete }: UseInvoiceFilesColumnsProps = {}): ColumnDef<SignedUrl>[] => {
  return useMemo<ColumnDef<SignedUrl>[]>(
    () => [
      {
        accessorKey: "fileType",
        header: "Type",
        enableSorting: false,
        size: 120,
        cell: ({ row }) => {
          const fieldGroup = row.original.file?.fieldGroup
          const label = isInvoiceDocumentFieldGroup(fieldGroup) ? INVOICE_DOCUMENT_TYPE_TO_LABEL[fieldGroup] : ""
          return <Chip className='mr-2 rounded-full bg-primary-200 text-gray-900' label={label} size='small' />
        },
      },
      {
        accessorKey: "file",
        header: "File",
        enableSorting: false,
        size: 200,
        cell: ({ row }) => <FileChip file={row.original} showExtension={true} />,
      },
      {
        accessorKey: "description",
        header: "Description",
        enableSorting: false,
        size: 300,
        cell: ({ row }) => row.original.file?.label ?? "",
      },
      {
        accessorKey: "actions",
        header: "",
        enableSorting: false,
        size: 50,
        cell: ({ row }) => <InvoiceDocumentRowActions row={row} onDelete={onDelete} />,
      },
    ],
    [onDelete]
  )
}
